let config = {
    emailjs: {
      serviceID: "service_6jzr5hc",
      templateID: "template_xo4ib78",
      userID: "user_2HpunYMJvXYisYV7YdtFw"
    }
  };
  
  export default config;